import { useEffect } from "react"

/** The document title with the Needs-you count (W23): "(3) Minga" when something needs you, else "Minga". */
export const badgeTitle = (base: string, count: number | null | undefined): string =>
  count && count > 0 ? `(${count > 99 ? "99+" : count}) ${base}` : base

/** Keep `document.title` in sync with the count while mounted; restores the plain title on unmount. */
export function useTitleBadge(base: string, count: number | null | undefined): void {
  useEffect(() => {
    document.title = badgeTitle(base, count)
  }, [base, count])
  useEffect(
    () => () => {
      document.title = base
    },
    [base],
  )
}
